import axios from 'axios';

export default {
    async getCleanCloudProducts() {
        await axios.get(`${process.env.Backend_URL}/sanctum/csrf-cookie`);
        return axios.post(`${process.env.API_URL}/get-products`);
    },
    getDefaultPrices() {
        return axios.get(`${process.env.API_URL}/get-category-default-prices`);
    },
    orderTimeSlots(type, form) {
        if (type == 'put') {
            return axios.put(`${process.env.API_URL}/time-slots/${form.id}`, form);
        }
        else if (type == 'post') {
            return axios.post(`${process.env.API_URL}/time-slots`, form);
        } else if (type == 'delete') {
            return axios.delete(`${process.env.API_URL}/time-slots/${form.id}`);
        }
        else {
            return axios.get(`${process.env.API_URL}/time-slots`);
        }
    },
    async usePromoCode(data) {
        //await axios.get(`${process.env.Backend_URL}/sanctum/csrf-cookie`);
        return axios.post(`${process.env.API_URL}/usepromocode`, data);
    }
};


// WEBPACK FOOTER //
// ./src/Apis/products.js